import React, { Component } from 'react'
import RaisedButton from 'material-ui/RaisedButton';
import Nav from './Nav';
import BigCalendar from 'react-big-calendar';
import moment from 'moment';
import FontAwesome from 'react-fontawesome'
import Hdept2DocStore from '../stores/Hdept2DocStore';
import Doc2HdeptStore from '../stores/Doc2HdeptStore';

const MyToolbar = (toolbar) => {
    const goToBack = () => {
        toolbar.date.setMonth(toolbar.date.getMonth() - 1);
        toolbar.onNavigate('prev');
    };

    const goToNext = () => {
        toolbar.date.setMonth(toolbar.date.getMonth() + 1);
        toolbar.onNavigate('next');
    };

    const label = () => {
        const date = moment(toolbar.date);

        return (
            <span>{date.format('YYYY')}年{date.format('MM')}月 <span style={{ color: 'orange' }}>{''}</span></span>
        );
    };

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            paddingLeft: '15px',
            paddingRight: '15px',
            paddingBottom: '8px',
            alignItems: 'center',
            zIndex: '1',
            background: 'linear-gradient(#EAEBED,#DDDEE2)'
        }}>
            <div onClick={goToBack}>
                <FontAwesome
                    name='angle-left'
                    size='2x'
                    style={{ textShadow: '0 1px 0 rgba(0, 0, 0, 0.1)' }}
                />
            </div>
            <label style={{ fontSize: 'larger' }}>{label()}</label>
            <div onClick={goToNext}>
                <FontAwesome
                    name='angle-right'
                    size='2x'
                    style={{ textShadow: '0 1px 0 rgba(0, 0, 0, 0.1)' }}
                />
            </div>
        </div>
    );
};

export default class ChoosePage extends Component {
    goHdept2Doc = () => {
        this.props.history.push("/hdept2doc")
    }

    goDoc2Hdept = () => {
        this.props.history.push("/doc2hdept")
    }

    componentWillMount() {
        Hdept2DocStore.load();
        Doc2HdeptStore.load();
    }

    render() {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'center', backgroundColor: 'rgba(0, 0, 0, 0.3)' }}>
                <div style={{ display: 'flex', flexDirection: 'column', position: 'absolute', width: '250px', right: '0', left: '0', margin: 'auto' }}>
                    <RaisedButton
                        label='依科別找醫師'
                        labelStyle={{ fontSize: '28px' }}
                        overlayStyle={{ height: '60px', lineHeight: '60px' }}
                        primary={true}
                        buttonStyle={{ backgroundColor: 'rgb(100, 181, 246)', width: '250px', height: '60px' }}
                        onClick={this.goHdept2Doc}
                        style={{ margin: '10px 0 0 0' }} />
                    <RaisedButton
                        label='依醫師找科別'
                        labelStyle={{ fontSize: '28px' }}
                        overlayStyle={{ height: '60px', lineHeight: '60px' }}
                        primary={true}
                        buttonStyle={{ backgroundColor: 'rgb(100, 181, 246)', width: '250px', height: '60px' }}
                        onClick={this.goDoc2Hdept}
                        style={{ margin: '10px 0 0 0' }} />
                    <Nav />
                </div>
                <BigCalendar
                    events={[]}
                    components={{
                        event: Event,
                        toolbar: MyToolbar
                    }}
                    /*date={Hdept2DocStore.date}*/
                    defaultDate={moment().toDate()}
                    views={['month']}
                    selectable={true}
                    popup={true}
                    // style={{ width: '100%', height: '100%', position: 'absolute' }}
                    style={{ zIndex: '-1', width: '100%', position: 'absolute' }}
                    eventPropGetter={this.eventStyleGetter}
                />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/ChoosePage.js